import React from "react";
import { BadgeInfo, X } from "lucide-react";

const QueryPopup = ({ userIsAdmin, msg, index, queryPopupIndex, toggleQueryPopup, popupRef }) => {
  if (!userIsAdmin || !msg.query) return null;
  
  // Function to format the SQL query with proper styling
  const renderFormattedQuery = (query) => {
    if (!query) return <p className="text-sm text-gray-500">No query information available</p>;
    
    return (
      <div className="text-gray-700 font-mono text-xs whitespace-pre-wrap bg-gray-50 p-3 rounded border border-gray-200">
        {query}
      </div>
    );
  };
  
  return (
    <>
      <BadgeInfo
        size={17}
        aria-label="View SQL query"
        className="absolute -bottom-2 -right-2 cursor-pointer bg-white rounded-full p-0.5 transition-all duration-200 hover:scale-110"
        style={{ color: '#6B7280', boxShadow: '0 2px 4px rgba(0,0,0,0.08)', border: '1px solid #E5E7EB' }}
        onMouseEnter={e => e.currentTarget.style.color = 'var(--color-primary)'}
        onMouseLeave={e => e.currentTarget.style.color = '#6B7280'}
        onClick={() => toggleQueryPopup(index)}
      />

      {queryPopupIndex === index && (
        <div
          className="animate-fadeIn"
          style={{
            position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 1001, backdropFilter: 'blur(4px)', backgroundColor: 'rgba(0,0,0,0.3)',
          }}
        >
          <div
            ref={popupRef}
            className="flex flex-col overflow-hidden bg-white"
            style={{
              position: 'absolute', top: '50%', left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '90%', maxWidth: '500px', maxHeight: '90%',
              borderRadius: '16px', boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
              border: '1px solid rgba(0,0,0,0.07)',
            }}
          >
            <div className="flex justify-between items-center px-4 py-3.5" style={{ borderBottom: '1px solid #F3F4F6' }}>
              <h2 className="text-sm font-semibold" style={{ color: '#1F2937' }}>SQL Query</h2>
              <button
                type="button"
                aria-label="Close query popup"
                onClick={() => toggleQueryPopup(null)}
                className="flex items-center justify-center w-7 h-7 rounded-lg transition-all duration-200"
                style={{ color: '#6B7280', border: 'none', background: 'transparent', cursor: 'pointer' }}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#F3F4F6'; e.currentTarget.style.color = '#1F2937'; }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#6B7280'; }}
              >
                <X size={16} />
              </button>
            </div>

            <div className="overflow-y-auto p-4 flex-grow max-h-[300px]" style={{ backgroundColor: '#F8F9FC' }}>
              <div
                className="bg-white p-4 font-mono text-xs whitespace-pre-wrap"
                style={{
                  borderRadius: '12px', border: '1px solid #E5E7EB',
                  color: '#374151', lineHeight: '1.6',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                }}
              >
                {msg.query || <span style={{ color: '#9CA3AF', fontStyle: 'italic' }}>No query available</span>}
              </div>
            </div>

            <div className="flex justify-end px-4 py-3" style={{ borderTop: '1px solid #F3F4F6' }}>
              <button
                type="button"
                onClick={() => toggleQueryPopup(null)}
                className="text-sm font-medium text-white transition-all duration-200"
                style={{
                  padding: '8px 16px', borderRadius: '8px', border: 'none',
                  background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%)',
                  cursor: 'pointer',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.03)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QueryPopup;